import React from "react";
// import { connect } from "react-redux";
import { INTERNAL_LINKS } from "enum";
import { Route } from "react-router-dom";
import { MainHeader, LandingHeader } from "components";

const LiveChatRouteSwiftHeader = () => {

    return (
        <>
            {localStorage.getItem("community") !== null ?
                <Route
                    path={`${INTERNAL_LINKS.LIVE_CHAT}`}
                    render={(props) => <MainHeader typeStyle={'black'} {...props} />}
                />
                :
                <Route
                    path={INTERNAL_LINKS.LIVE_CHAT}
                    exact
                    render={(props) => <LandingHeader {...props} />}
                />
            }

        </>
    );
};

// const mapStateToProps = (state) => ({
// });

// const mapDispatchToProps = {
// };

export default LiveChatRouteSwiftHeader;